import { useMutation } from 'react-query';
import { companyService } from 'hq/services';
import { CreateCompanyGrossHourlyRatePayload } from 'hq/services/company-service.types';

export const useCreateCompanyGrossHourlyRate = () => {
  const mutationFn = async (payload: CreateCompanyGrossHourlyRatePayload) =>
    await companyService.createCompanyGrossHourlyRate(payload);

  return useMutation(mutationFn);
};
